import { ReceiptLine } from '@baemingo/receipt';
import { PrintRow } from '~Components/PrinterManager';

/** Font size the native printer apps use for a regular receipt line. */
const RECEIPT_FONT_SIZE = 13;

/** Font size used for double height/width receipt lines (titles, order number). */
const RECEIPT_LARGE_FONT_SIZE = 26;

/**
 * Converts the lines produced by @baemingo/receipt into rows for PrinterManager.
 *
 * The text is already padded to the printer width, so alignment is carried in the spaces.
 * Native printer apps only read `content` and `fontSize` for receipts; the Adyen terminal
 * renderer also honours `bold` and uses `alignment` for rows that are not pre-padded.
 */
export const receiptLinesToPrintRows = (lines: ReceiptLine[]): PrintRow[] =>
  lines.map((line) => ({
    content: line.text,
    fontSize:
      line.fontSize ||
      (line.doubleHeigth || line.doubleWidth ? RECEIPT_LARGE_FONT_SIZE : RECEIPT_FONT_SIZE),
    bold: line.bold,
    alignment: line.align,
  }));
